import styled from 'styled-components';

export const SearchStyle = styled.div`
  .searchDiv {
    width: 100%;
    height: 100%;
    margin-top: 1px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }
  .heading {
    display: block;
    height: 15px;
    display: block;
    color: #6b6b6b;
    font-size: 12px;
    font-weight: 700;
    line-height: 15px;
    margin-top: 0;
    margin-bottom: 4px;
    margin-left: 2px;
  }
  .searchDiv .kallos-form-group,
  .searchDiv .kallos-form-input-group {
    height: 35px;
    min-height: 35px;
    font-size: 13px;
    box-sizing: border-box;
  }
  .searchDiv .kallos-form-input-group {
    border: 2px solid #96a0a8;
    border-radius: 5px;
    align-items: center;
  }
  .searchDiv .kallos-form-control {
    height: 31px;
    min-height: 31px;
    padding: 7px 34px 7px 12px;
    box-sizing: border-box;
    color: #0f215f;
    font-size: 13px;
    font-weight: 500;
    line-height: 18px;
  }
  .searchDiv .kallos-form-control::placeholder {
    color: #7d8baa;
    font-size: 12px;
    font-weight: 400;
    opacity: 1;
  }
  .searchIcon {
    position: absolute;
    top: 34px;
    right: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    color: #0e215f;
    font-size: 18px;
  }
`;
